import {useQuery} from '@tanstack/react-query';
import {useShallowDebounce} from '~/library/ui-kit';
import {FeeRequestData, useFeesOnSendOptions} from '~/processes/crypto-send-and-receive/api/fetchFeesOnSend';

export function useFetchFeesOnSell(data: FeeRequestData) {
    const {isDebouncing, value} = useShallowDebounce(400, data);
    const options = useFeesOnSendOptions(value);
    const result = useQuery(options);

    return {...result, isDebouncing};
}

export {FeeRequestData};
